import React from 'react';
import PostDraftBarPublishButton from './PostDraftBarPublishButton';
import { getStateIcon } from './PostIcon';
import {
  isAllowedThroughLinkAccess,
  PostPolicyAction,
} from './postPolicyCheck';
import type { PostStateBarComponentProps } from './PostStateBar';
import PostViewStateBar from './PostViewStateBar';
import SVGIcon from '../components/SVGIcon';
import Tooltip from '../components/Tooltip';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { PostType } from '../graphql/generated/graphql';
import publicIcon from '../icons/non-prefilled/16x16/public.svg';
import { UserRole } from '../topic/topicPolicyCheck';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';

const POST_FRAGMENT = gql(`
  fragment PostDraftBar_post on Post {
    id
    type
    ...PostDraftBarPublishButton_post
    ...isAllowedThroughLinkAccess_post
  }  
`);

interface PostDraftBarProps extends PostStateBarComponentProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PostDraftBar = ({ post }: PostDraftBarProps) => {
  const isMobile = useIsSize(Sizes.SM);

  const isPublic = isAllowedThroughLinkAccess(
    PostPolicyAction.ViewPost,
    post,
    UserRole.Anonymous,
  );

  return (
    <PostViewStateBar
      actions={<PostDraftBarPublishButton post={post} size="small" />}
    >
      <SVGIcon>
        {getStateIcon({
          type: post.type,
          draft: true,
          archived: false,
        })}
      </SVGIcon>
      <strong>
        {post.type === PostType.Template ? 'Draft Template' : 'Draft'}
      </strong>
      {isPublic && (
        <>
          {!isMobile && (
            <div>Publish to make this discoverable by teammates</div>
          )}
          <Tooltip
            trigger="clickOrHover"
            content={'Logged out visitors\ncan access this post\nwith its URL'}
            placement="bottom"
          >
            <SVGIcon>{publicIcon}</SVGIcon>
          </Tooltip>
        </>
      )}
    </PostViewStateBar>
  );
};

export default PostDraftBar;
